import EditManualAccount from '../../../onboarding/components/EditManualAccount';

export default function EditManualAccountScreen() {
    return <EditManualAccount />;
}
